import React from 'react'
import { Text, Title, Icon } from 'components'
import ClassNames from 'classnames'
import { getFullAddress, getCityState, getCEP } from '../../lib/resaleInfos'
import styles from './ContactsList.module.scss'

const socialNetworks = [
  {
    icon: <Icon type="facebook" size={32} />,
    link: 'https://www.facebook.com/resale.com.br/',
  },
  {
    icon: <Icon type="instagram" size={32} />,
    link: 'https://www.instagram.com/resalebr/',
  },
  {
    icon: <Icon type="linkedin" size={32} />,
    link: 'https://www.linkedin.com/company/resalebr',
  },
  {
    icon: <Icon type="youtube" size={32} />,
    link:
      'https://www.youtube.com/channel/UCOQPpSCHs1NPfeJYsOi1AnQ/featured?view_as=subscriber',
  },
]

const ContactsList = () => {
  return (
    <div className={styles.contactsList}>
      <div className={ClassNames(styles.section, styles.first)}>
        <div className={styles.textWrapper}>
          <Title fontSize="medium" color="darkBlueColor" type="h2">
            Telefone
          </Title>
          <Text fontSize="medium" color="lightTextColor">
            (19) 3422 6222
          </Text>
          <Text fontSize="medium" color="lightTextColor">
            Seg a Sex - 9h às 18h
          </Text>
        </div>
      </div>
      <div className={ClassNames(styles.section, styles.second)}>
        <div className={styles.textWrapper}>
          <Title fontSize="medium" color="darkBlueColor" type="h2">
            E-mail
          </Title>
          <Text fontSize="medium" color="lightTextColor">
            contato@resale.com.br
          </Text>
        </div>
      </div>
      <div className={ClassNames(styles.section, styles.third)}>
        <div className={styles.textWrapper}>
          <Title fontSize="medium" color="darkBlueColor" type="h2">
            Nossa sede
          </Title>
          <Text fontSize="medium" color="lightTextColor">
            {getFullAddress()}
          </Text>
          <Text fontSize="medium" color="lightTextColor">
            {getCityState()}
          </Text>
          <Text fontSize="medium" color="lightTextColor">
            {getCEP()}
          </Text>
        </div>
      </div>
      <div className={ClassNames(styles.section, styles.last)}>
        <div>
          <Title fontSize="medium" color="darkBlueColor" type="h2">
            Redes sociais
          </Title>
          <div className={styles.socialNetworks}>
            {socialNetworks.map(({ link, icon }) => (
              <a
                href={link}
                className={styles.linkNetwork}
                key={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(ContactsList)
